export default "__VITE_ASSET__Cb$VKeeN__"